export default "__VITE_ASSET__DW$jgn8S__"